const textProps = {
  defaultOpened: 0,
  items: [
    {
      title: "Andrew Lino",
      description:
        "Take up one idea. Make that one idea your life, think of it, dream of it, live on that idea. Let the brain, muscles, nerves, every part ofyour body, be full of that idea, and just leave every other idea alone. This is the way to success. A single rose can be my garden... a single friend, my world.",
      image: require("assets/img/faces/team-1.jpg").default,
    },
    {
      title: "Michael Jenos",
      description:
        'Artist is a term applied to a person who engages in an activity deemed to be an art. An artist also may be defined unofficially as "a person who expresses him- or herself through a medium". He is a descriptive term applied to a person who engages in an activity deemed to be an art.',
      image: require("assets/img/faces/team-2.jpg").default,
    },
    {
      title: "Rose Arthur",
      description:
        "The simplest visual description uses ordinary words to convey what the writer sees. First he or she must look at the subject – slowly, carefully, and repeatedly, if possible – to identify the parts that make the whole",
      image: require("assets/img/faces/team-3.jpg").default,
    },
    {
      title: "Lora Jimi",
      description:
        "Finding temporary housing for your dog should be as easy as renting an Airbnb. That’s the idea behind Rover, which raised $65 million to expand its pet sitting and dog-walking businesses..Finding temporary housing for your dog should be as easy as renting an Airbnb.",
      image: require("assets/img/faces/team-4.jpg").default,
    },
    {
      title: "Mike Ranson",
      description:
        "Venture investment in U.S. startups rose sequentially in the second quarter of 2017, boosted by large, late-stage financings and a few outsized early-stage rounds in tech and healthcare..enture investment in U.S. startups rose sequentially in the second quarter of 2017, boosted by large.",
      image: require("assets/img/faces/team-5.jpg").default,
    },
  ],
};
export default textProps;
